<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/custom/qunlong/first/inspection/pageWoList" getKey="rows" :pageSizes="pageSizes" :columns="columns" @selectionChange="selectionChange" @afterGet="afterReq">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shebeimingcheng')">
            <el-input v-model="yt.conditions.searchText"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1, beforeReq, afterReq)" type="primary" plain>
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ statusList: ['2', '3', '4'], orderBy: 'priority asc' }, beforeReq, afterReq)">
              {{ $t('chongzhi') }}
            </el-button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 自定义某个字段 -->
      <template #beizhu="scope">
        <div @click="$event.stopPropagation()">
          <el-input v-model="scope.row.remark" :maxlength="400"></el-input>
        </div>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" type="primary" @click="moveUp" :disabled="buttonStatus1" v-if="utils.checkPower('web_production_management_work_order_execution_single_adjust_button')">
          {{ $t('shangyi') }}
        </el-button>
        <el-button size="mini" type="primary" @click="moveDown" :disabled="buttonStatus1" v-if="utils.checkPower('web_production_management_work_order_execution_single_adjust_button')">
          {{ $t('xiayi') }}
        </el-button>
        <el-button size="mini" type="default" @click="moveFirst" :disabled="buttonStatus1" v-if="utils.checkPower('web_production_management_work_order_execution_single_adjust_button')">
          {{ $t('zuishang') }}
        </el-button>
        <el-button size="mini" type="default" @click="moveLast" :disabled="buttonStatus1" v-if="utils.checkPower('web_production_management_work_order_execution_single_adjust_button')">
          {{ $t('zuixia') }}
        </el-button>
        <el-button size="mini" type="primary" @click="yt.showEditDialog('diaobo', null, 'w1')" :disabled="buttonStatus1" v-if="utils.checkPower('web_production_management_work_order_execution_single_adjust_button')">
          {{ $t('diaobo') }}
        </el-button>
        <el-button size="mini" type="danger" @click="closeWo" :loading="closeWoLoading" :disabled="tableList.length === 0" v-if="utils.checkPower('web_production_management_work_order_execution_single_adjust_button')">
          {{ $t('guanbi') }}
        </el-button>
        <!--        <el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'850px')" type="primary">-->
        <!--          {{$t('xinzeng')}}-->
        <!--        </el-button>-->
      </template>
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope"> </template>
    </yi_curd_table>
    <el-dialog v-dialog-drag :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <template v-if="yt.editObj.action == 'diaobo'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth" v-for="(item, index) in tableList" :key="index">
          <el-form-item class="noborder" :label="$t('shengchangongdanhao')" required>
            <el-input disabled v-model="item.no"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('chanpinbianma/mingcheng')" required>
            <yi_cross_select disabled multiple :selectTitle="'code,name'" :component="'web_base_matter_list'" :ids.sync="item.materialId"></yi_cross_select>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('jihuashuliang')" required>
            <el-input disabled v-model="item.planQuantity"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('shengyushengchanshuliang')">
            <el-input disabled v-model="item.leftProductionQuantity"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mujubianhao/mingcheng')" required>
            <yi_cross_select :max="1" :selectTitle="'no,name'" :component="'web_order_management_production_plan_mold_list'" :ids.sync="item.mouldId" :materialId="item.materialId"></yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')" required>
            <yi_cross_select :max="1" :component="'web_production_management_work_order_execution_equipment_list'" :ids.sync="item.equipmentId" :mouldId="item.mouldId" :materialId="item.materialId"></yi_cross_select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <!--          id=yt.editObj.id;equipmentId=yt.editObj.equipmentId;mouldId=yt.editObj.mouldId;yt.req('POST','/web/production/wo/allot')-->
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="allot" type="primary" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '工单执行-单机调整' } }">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import Bury from '@/common/bury.js';

// import work_bom from '@@/pages/web/order_management/erp/work_bom'
export default {
  name: 'web_production_management_work_order_execution_single_adjust',
  components: {
    // work_bom
  },
  data() {
    return {
      tableList: [],
      closeWoLoading: false,
      columns: [
        {
          label: 'xuanze',
          type: 'selection'
        },
        {
          label: 'dingdanfenluID',
          prop: 'plan.orderEntryId'
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name'
        },
        {
          label: 'mujumingcheng',
          prop: 'mould.name'
        },
        {
          label: 'huohao',
          prop: 'plan.articleNumber'
        },
        {
          label: 'wuliaomingcheng',
          prop: 'material.name'
        },
        {
          label: 'dingdanzhongliang(KG)',
          prop: 'weight'
        },
        {
          label: 'danzhong(G)',
          prop: 'singleWeight'
        },
        {
          label: 'shijimoqiangshu',
          prop: 'actualCavity'
        },
        {
          label: 'biaozhun/shijizhouqi(miao)',
          prop: 'standardCycle_actualCycle'
        },
        {
          label: 'beizhu',
          prop: 'remark',
          type: 'slot'
        },
        {
          label: 'gongdanpaixu',
          prop: 'priority'
        },
        {
          label: 'gongdanzhuangtai',
          type: 'tag',
          prop: 'status',
          width: 130,
          tags: {
            1: {
              color: '#419FFF',
              text: this.$t('xinjian')
            },
            2: {
              color: '#419FFF',
              text: this.$t('fafang')
            },
            3: {
              color: '#67C23A',
              text: this.$t('shengchanzhong')
            },
            4: {
              color: '#F56C6C',
              text: this.$t('zanting')
            },
            5: {
              color: '#67C23A',
              text: this.$t('shougongxuwangong')
            },
            6: {
              color: '#67C23A',
              text: this.$t('wangong')
            },
            7: {
              color: '#909399',
              text: this.$t('guanbi')
            },
            8: {
              color: '#E6A23C',
              text: this.$t('yidiaobo')
            }
          }
        }
      ],
      selectIds: [],
      pageSizes: [20, 50, 100]
    };
  },
  computed: {
    buttonStatus1() {
      if (this.tableList.length === 1 && (this.tableList[0].status === 2 || this.tableList[0].status === 4)) {
        return false;
      }
      return true;
    }
  },
  created() {
    setTimeout(() => {
      this.yt.pageSize = 20;
      this.yt.conditions = {
        statusList: ['2', '3', '4'],
        orderBy: 'priority asc'
      };
      this.yt.get(1, this.beforeReq, this.afterReq);
    }, 300);
  },
  watch: {
    'yt.list': {
      handler(n) {
        this.$emit('list-change', n);
      },
      immediate: false,
      deep: true
    }
  },
  methods: {
    // 关闭工单
    closeWo() {
      if (this.tableList.length === 0) {
        return;
      }
      Bury.buryAdd({ functionType: '用户行为', logType: '按钮点击', startData: { s1: '工单执行-单机调整-关闭工单' } });
      let count = this.tableList.length;
      const that = this;
      const end = function () {
        count--;
        if (count === 0) {
          that.closeWoLoading = false;
          that.yt.get();
        }
      };
      for (let i = 0; i < this.tableList.length; i++) {
        this.closeWoLoading = true;
        const row = this.tableList[i];
        const woId = row.id;
        const orderEntryId = row.plan ? row.plan.orderEntryId : '';
        this.reqCloseWo(woId, orderEntryId, end);
      }
    },
    // 请求关闭工单
    reqCloseWo(id, orderEntryId, end) {
      this.http
        .post('/web/production/wo/close', id)
        .then(res => {
          this.$message.success(this.$t(res.msg));
          this.selectIds = [];
          this.tableList = [];
        })
        .catch(err => {
          this.$message.error(`订单分录ID: ${orderEntryId}, ` + this.$t(err));
        })
        .finally(() => {
          end();
        });
    },
    selectionChange(items) {
      // this.tableList = items
      console.log('111111', items);
      // if (items.length > 1) {
      //   if (items[1].status === 3) {
      //     this.yt.list.forEach(row => {
      //       if (row['id'] === items[1]['id']) {
      //         this.yt.$refs.table.toggleRowSelection(row, false);
      //       }
      //     });
      //     items.splice(1, 1);
      //   } else {
      //     this.yt.list.forEach(row => {
      //       if (row['id'] === items[0]['id']) {
      //         this.yt.$refs.table.toggleRowSelection(row, false);
      //       }
      //     });
      //     items.splice(0, 1);
      //   }
      // } else if (items.length === 1 && items[0].status === 3) {
      //   this.yt.list.forEach(row => {
      //     if (row['id'] === items[0]['id']) {
      //       this.yt.$refs.table.toggleRowSelection(row, false);
      //     }
      //   });
      //   items = [];
      // }
      // 保证只选中一行
      this.tableList = items;
      this.selectIds = this.tableList.map(i => {
        return i['id'];
      });
    },
    beforeReq(params) {
      return params;
    },
    afterReq(result) {
      let list = this.yt.list;
      if (list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          let row = list[i];
          row.standardCycle_actualCycle = (row.standardCycle == null ? '-' : row.standardCycle) + '/' + (row.actualCycle == null ? '-' : row.actualCycle);
          this.$set(row, 'remark', row.remark);
          if (this.yt.conditions.searchText && this.yt.conditions.searchText != '') {
            row.priority = i + 1;
          }
        }
      }
      return result;
    },
    moveUp() {
      if (this.buttonStatus1) {
        return;
      }
      if (this.selectIds.length === 1) {
        let list = this.yt.list;
        for (let i = 0; i < list.length; i++) {
          let item = list[i];
          if (item['id'] === this.selectIds[0]) {
            if (i === 0) {
              return;
            } else if (list[i - 1].status === 3) {
              return;
            } else {
              let temp = list[i - 1];
              temp.priority = temp.priority + 1;
              item.priority = item.priority - 1;
              list[i - 1] = item;
              list[i] = temp;
              if (list[i - 1].priority <= 0) {
                let n = 1 - list[i - 1].priority;
                list[i - 1].priority = 1;
                list[i].priority = list[i].priority - 1;
                for (let j = i; j < list.length; j++) {
                  list[j].priority = list[j].priority + n;
                }
              }
            }
            this.$set(this.yt, 'list', list);
            this.yt.$forceUpdate();
            return;
          }
        }
      }
    },
    moveDown() {
      if (this.buttonStatus1) {
        return;
      }
      if (this.selectIds.length === 1) {
        let list = this.yt.list;
        for (let i = 0; i < list.length; i++) {
          let item = list[i];
          if (item['id'] === this.selectIds[0]) {
            if (i === list.length - 1) {
              return;
            } else {
              let temp = list[i + 1];
              temp.priority = temp.priority - 1;
              item.priority = item.priority + 1;
              list[i + 1] = item;
              list[i] = temp;
            }
            this.$set(this.yt, 'list', list);
            this.yt.$forceUpdate();
            return;
          }
        }
      }
    },
    moveFirst() {
      if (this.buttonStatus1) {
        return;
      }
      if (this.selectIds.length === 1) {
        let list = this.yt.list;
        for (let i = 0; i < list.length; i++) {
          let item = list[i];
          if (item['id'] === this.selectIds[0]) {
            if (i === 0) {
              return;
            } else {
              let temp = list[i];
              temp.priority = list[0].priority;
              for (let j = i; j > 0; j--) {
                list[j] = list[j - 1];
                list[j].priority = list[j].priority + 1;
              }
              list[0] = temp;
            }
            this.$set(this.yt, 'list', list);
            this.yt.$forceUpdate();
            return;
          }
        }
      }
    },
    moveLast() {
      if (this.buttonStatus1) {
        return;
      }
      if (this.selectIds.length === 1) {
        let list = this.yt.list;
        for (let i = 0; i < list.length; i++) {
          let item = list[i];
          if (item['id'] === this.selectIds[0]) {
            if (i === list.length - 1) {
              return;
            } else {
              let temp = list[i];
              for (let j = i; j < list.length - 1; j++) {
                list[j] = list[j + 1];
                list[j].priority = list[j].priority - 1;
              }
              temp.priority = list[list.length - 1].priority + 1;
              list[list.length - 1] = temp;
            }
            this.$set(this.yt, 'list', list);
            this.yt.$forceUpdate();
            return;
          }
        }
      }
    },
    //调拨
    async allot() {
      if (this.buttonStatus1) {
        return;
      }
      const editObj = this.tableList[0];
      let params = {
        id: editObj.id,
        equipmentId: editObj.equipmentId,
        mouldId: editObj.mouldId
      };
      return await this.http
        .post('/web/production/wo/allot', params)
        .then(res => {
          this.yt.isShowEditDialog = false;
          this.yt.get(1, this.beforeReq, this.afterReq);
          this.$message.success(this.$t('success'));
          this.selectIds = !this.selectIds;
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    }
  }
};
</script>
